<template>
  <div class="navigation-menu-branch">
    <v-list-group
      v-if="isGroup"
      :sub-group="depth > 0"
      prepend-icon=""
      color="accent"
      no-action
      @click.stop="onGroupClick"
    >
      <v-icon slot="appendIcon" small>fas fa-chevron-down</v-icon>
      <template v-slot:activator>
        <v-icon
          v-if="depth === 0"
          slot="prependIcon"
          class="ml-1 py-3"
          style="width: 15px"
          small
        >
          {{ item.icon }}
        </v-icon>
        <v-list-item-content v-if="depth === 0">
          <v-list-item-title class="ml-5 font-weight-bold">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item
          v-if="depth > 0"
          :style="groupStyle"
          :title="nestedTitle"
          dense
        >
          <v-list-item-icon class="mr-0">
            <v-icon x-small>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <navigation-menu-branch
        v-for="(child, i) in item.children"
        :key="branchKey(child, i)"
        :item="child"
        :depth="depth + 1"
        @subir_vista="$emit('subir_vista')"
        @change_size="$emit('change_size', $event)"
      />
    </v-list-group>

    <v-list-item
      v-else
      :class="leafClass"
      :style="leafStyle"
      :title="nestedTitle"
      color="white"
      :to="item.href"
      link
      @click.stop="$emit('subir_vista')"
    >
      <v-list-item-icon :class="topLevelLeaf ? '' : 'mr-0'">
        <v-icon
          class="ml-1"
          style="width: 15px"
          :small="topLevelLeaf"
          :x-small="!topLevelLeaf"
        >
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>
      <v-list-item-content :class="topLevelLeaf ? 'ml-n4' : ''">
        <v-list-item-title :class="topLevelLeaf ? '' : 'font-weight-regular'">
          {{ item.text }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: 'NavigationMenuBranch',
  props: {
    item: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isGroup () {
      return this.item.children && this.item.children.length > 0
    },
    topLevelLeaf () {
      return this.depth === 0
    },
    nestedTitle () {
      return this.depth >= 2 ? this.item.text : undefined
    },
    leafClass () {
      if (this.depth === 0) return ''
      if (this.depth === 1) return 'pl-8'
      return ''
    },
    leafStyle () {
      if (this.depth <= 1) return undefined
      return { paddingLeft: `${24 + this.depth * 18}px` }
    },
    groupStyle () {
      if (this.depth <= 1) return undefined
      return { paddingLeft: `${8 + this.depth * 14}px` }
    }
  },
  methods: {
    branchKey (child, i) {
      const id = child.href != null ? String(child.href) : ''
      return `${this.depth}-${i}-${id}-${child.text || ''}`
    },
    countLeaves (node) {
      if (!node.children || !node.children.length) return 1
      return node.children.reduce((sum, c) => sum + this.countLeaves(c), 0)
    },
    onGroupClick () {
      this.$emit('change_size', this.countLeaves(this.item))
    }
  }
}
</script>
